import {
  requestWatchVideoList,
  requestWatchVideo,
} from '@/api/watchVideo';

const state = {
  watchVideoList: null,
  watchVideoResult: null,
};

const getters = {
  watchVideoList: (state) => state.watchVideoList,
  watchVideoResult: (state) => state.watchVideoResult,
};

const actions = {
  async setWatchVideoList({ commit }) {
    // await dispatch('setIsLoading', true, { root: true });
    const result = await requestWatchVideoList();
    commit('setWatchVideoList', result.data);
    // await dispatch('setIsLoading', false, { root: true });
  },
  clearWatchVideoList({ commit }) {
    commit('setWatchVideoList', null);
  },
  async setWatchVideo({ commit }, { id }) {
    // await dispatch('setIsLoading', true, { root: true });
    const result = await requestWatchVideo({ id });
    commit('setWatchVideo', result.data);
    // await dispatch('setIsLoading', false, { root: true });
  },
  clearWatchVideo({ commit }) {
    commit('setWatchVideo', null);
  },
};

const mutations = {
  setWatchVideoList(state, watchVideoList) {
    state.watchVideoList = watchVideoList;
  },
  setWatchVideo(state, watchVideoResult) {
    state.watchVideoResult = watchVideoResult;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
